
<template>

  <div id="page-incident-view">
        <upload-video-sidebar :isSidebarActive="uploadVideoSidebar" @closeSidebar="uploadVideotoggleDataSidebar"  :data="uploadVideoSidbarData" />
        <add-incident-sidebar :isSidebarActive="editIncidentaSidebar" @closeSidebar="edittoggleDataSidebar"  :data="editsidebarData" />
        <edit-video-sidebar :isSidebarActive="editVideoSidebar" @getdata="getdata" @closeSidebar="editVideotoggleDataSidebar"  :data="editVideosidebarData" />

     <div >
      <vx-card>
     <template slot="no-body">

        <div class="item-content">

          <!-- Item Main Info -->
        <div class="product-details p-6">
            <div class="vx-row mt-6">
              <!-- Item Content -->
              <div class="vx-col w-full">
                <h3>{{incident.name}}</h3>
                <p class="my-2" v-if="incident.requested_by">
                  <span class="leading-none ont-semibold font-medium mr-2">By:</span>
                  <span>{{incident.requested_by.username}}</span>
                </p>
                <p class="flex items-center flex-wrap">
                  <vs-chip v-if="incident.status" class="leading-none font-medium">{{incident.status}}</vs-chip>
                  <vs-chip v-else class="leading-none font-medium">Requested</vs-chip>
                </p>
                  <p class="flex items-center flex-wrap mt-3">
                  <span class="cursor-pointer leading-none ont-semibold font-medium">Created :  </span>
                  <span class="ml-1">{{ incident.created_at | formatDate}}</span>
                </p>
                   <p class="flex items-center flex-wrap mt-3">
                  <span class="cursor-pointer leading-none ont-semibold font-medium">Location :  </span>
                  <span class="ml-1">{{ incident.location.name}}</span>
                </p>
                <vs-divider />
                <p style="word-break: break-all">{{incident.details}}</p>
                <vs-divider />
                 <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click.native="editNewData(incident)">{{ $t('common.edit') }}</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click.native="confirmDeleteRecord(incident)">{{ $t('common.delete') }}</vs-button>
          </div>
        </div>
        </div>
        </div>
        </div>
      </template>
      </vx-card><br>
       <div class="flex flex-wrap-reverse items-center data-list-btn-container" v-if="incident.incident_videos">
       <h3 class="ml-5">Videos</h3>
          <!-- ADD NEW -->
          <!-- <div v-if="role=='admin'" class="btn-add-new p-3 ml-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="uploadVideo(incident)">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Upload Video</span>
          </div> -->
        </div>
            <p v-if="incident.incident_videos.length===0" class="ml-5 text-left mt-5">No video available</p>
      <div class="vx-row mt-5" >
         <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(video, index) in incident.incident_videos" :key="index">
            <vx-card >
            <img v-if="video.video=='Upload Pending'" src="@/assets/images/pages/upload_pending.jpg" alt="upload pending" class="mx-auto responsive">
              <!-- <img v-if="video.video=='Upload Pending'" src="@/assets/images/pages/upload_pending.jpg" alt="login" class="mx-auto">
               <img  :src="img_cdn+'upload_pending.jpg'" class="responsive"> -->
          <!-- <div  v-if="video.video=='Upload Pending'"
          style=" background-color: #f6f6f6;
         width: 100%;
         padding: 60px;
         margin-bottom:5px;
         font-weight: bold;
         text-align: center"
         >Upload Pending</div> -->

              <!-- <svg width="100%" height="160px" v-if="video.video=='Upload Pending'">
  <rect width="100%" height="160px" style="fill:rgb(240,240,240);stroke-width:3;stroke:rgb(240,240,240)" />
  Sorry, your browser does not support inline SVG.
</svg> -->
               <!-- <vs-chip class="ml-20 mb-5 text-center"  color="primary">Upload Pending</vs-chip>  -->
                <!-- <video controls :src='video_cdn+video.video'  width="100%"></video> -->
                <video v-else controls :src="video.video"  width="100%"></video>


                    <!-- <template slot="no-body">
                        <video-player ref="player"
                         :playsinline="true"
                         class="media-video-player card-video video-player-box" :options='playerOptions'/>
                    </template> -->

               <table>
              <tr>
                <td class="font-semibold">Camera : </td>
                <td> <vs-chip  color="primary">
               <vs-avatar icon-pack="feather" icon="icon-camera" :color="video.camera.color_code" />
              {{video.camera.name}}
              </vs-chip></td>
              </tr>
               <tr>
                <td class="font-semibold">Start time : </td>
                <td>{{video.start_time | formatTime}}</td>
              </tr>
              <tr>
                <td class="font-semibold">End time : </td>
                <td>{{video.end_time | formatTime}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Date : </td>
                <td>{{video.date}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Created: </td>
                <td style="float:right">{{video.created_at | formatDate}}</td>
              </tr>
              <!-- <tr>
                <td class="font-semibold">Download: </td>
                <td><vs-button color="success" size="small" type="filled"  @click="confirmDeleteVideoRecord(video)">0</vs-button></td>
              </tr> -->
               </table>
                             <!-- <tr class="mt-5">
                <td><vs-button color="primary" size="small" type="filled" @click="editVideoData(video)">Edit</vs-button></td>
                <td style="float:right"><vs-button color="danger" size="small" type="filled"  @click="confirmDeleteVideoRecord(video)">Remove</vs-button></td>
              </tr> -->
              <vs-row>
  <vs-col v-if="role=='admin'" vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
    <vs-button v-if="video.video!='Upload Pending'"  color="primary" size="small" type="filled" @click.native="editVideoData(incident.location.id,video)">Edit</vs-button>
    <vs-button v-else style="text-align:left;padding-left:6px;padding-right:6px" color="primary" size="small" type="filled" @click.native="editVideoData(incident.location.id,video)">Upload Video</vs-button>

  </vs-col>
  <vs-col  v-if="role=='admin'"  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
   <vs-button color="danger" size="small" type="filled"  @click.native="confirmDeleteVideoRecord(video)">Remove</vs-button>
  </vs-col>
  <vs-col  vs-type="flex" v-if="video.video!='Upload Pending'" vs-justify="center" vs-align="center" vs-w="4">
<!--    <vs-button color="success" size="small" type="filled"><a class="text-white" :href="video_server_cdn+'download/'+video.video" >Download</a></vs-button>-->
    <vs-button color="success" size="small" type="filled"><a class="text-white" @click="downloadFile(video.file_name)" >Download</a></vs-button>
  </vs-col>
</vs-row>
  </vx-card>
            </div>

            <!-- <vx-card class="overflow-hidden">
                    <template slot="no-body">
                        <video-player ref="player" controls='true' class="media-video-player card-video" :options='playerOptions'/>
                    </template>
                </vx-card> -->

             </div>

    </div>
  </div>
</template>
<script>
import { videoPlayer }     from 'vue-video-player'
import UploadVideoSidebar from './UploadVideoSidebar.vue'
import AddIncidentSidebar from './AddIncidentSidebar.vue'
import EditVideoSidebar from './EditVideoSidebar.vue'
import {
  GET_SINGLE_INCIDENT,
  REMOVE_INCIDENT,
  DELETE_INCIDENT_SINGLE_VIDEOS,
  DOWNLOAD_TICKET_ATTACHMENT
} from '@/graphql'
import moment from 'moment'

export default {
  components: {
    videoPlayer,
    moment,
    UploadVideoSidebar,
    AddIncidentSidebar,
    'edit-video-sidebar': EditVideoSidebar


  },
  data () {
    return {
      role:'',
      incident:'',
      uploadVideoSidebar: false,
      uploadVideoSidbarData: {},
      editIncidentaSidebar: false,
      editVideoIncidentaSidebar: false,
      editsidebarData: {},
      editVideoSidebar:false,
      editVideosidebarData: {},
      DeletedItem:'',
      img_cdn: '',


      // playerOptions: {
      // //   controls: true,
      //   autoplay: true,
      //   muted: true,
      //   language: 'en',
      //   sources: [{
      //     type: "video/mp4",
      //     // mp4
      //     //   src:this.video_cdn
      //     src: "http://vjs.zencdn.net/v/oceans.mp4",
      //     // webm
      //     // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
      //   }],
      // },
      video_cdn:'',
      video_server_cdn:''
    }
  },
  filters:{
    formatDate (value) {
      if (value) {
       return moment.utc(value).local().format('MM/DD/YYYY h:mm A');
      }
    },
    formatTime (value) {
      if (value) {
        return moment(String(value), 'h:mm A').format('h:mm A')
      }
    }
  },
  methods: {
    downloadFile (file) {
      this.$apollo
        .mutate({
          mutation: DOWNLOAD_TICKET_ATTACHMENT,
          variables: {
            file
          }
        })
        .then(response => {
          window.location = response.data.downloadTicketAttachment
          this.get()

        }
        )
    },
    confirmDeleteVideoRecord (data) {
    // console.log(data)
      this.DeletedItem = data
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'You are about to permanently delete this video',
        accept: this.removeVideoData,
        acceptText: 'Delete'
      })
    },
    removeVideoData () {
      this.$apollo
        .mutate({
          mutation: DELETE_INCIDENT_SINGLE_VIDEOS,
          variables: {
            id: this.DeletedItem.id,
            file_name: this.DeletedItem.file_name
          }
        })
        .then(response => {
          console.log(response)
          this.get()

        }
        )


    },
    getdata (value) {
      if (value) {
        this.get()
      }
    },
    edittoggleDataSidebar (val = false) {
      this.editIncidentaSidebar = val
      if (!val) {
        this.get()
      }
    },
    editVideotoggleDataSidebar (val = false) {
      this.editVideoSidebar = val
    },
    editVideoData (location, data) {
      data.location = location
      this.editVideosidebarData = data
      this.editVideotoggleDataSidebar(true)
    },
    uploadVideotoggleDataSidebar (val = false) {
      this.uploadVideoSidebar = val
      if (!val) {
        this.get()
      }
    },
    uploadVideo (data) {
      this.uploadVideoSidbarData = data
      this.uploadVideotoggleDataSidebar(true)
    },
    editNewData (data) {
      this.editsidebarData = data
      this.edittoggleDataSidebar(true)
    },
    confirmDeleteRecord (incident) {
      this.DeletedItem = incident.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${incident.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.$apollo
        .mutate({
          mutation: REMOVE_INCIDENT,
          variables: {
            id: this.DeletedItem
          }
        })
        .then(response => {
          if (response) {
            this.StatusSuccess()
            this.$router.push('/incidents')
          }
        }).catch(error => {
          console.log(error)
        })
    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'Incident',
        text:   'Incident deleted successfully',
        color:  'success',
        position: 'top-right'
      })
    },
    get () {
      this.$apollo
        .mutate({
          mutation: GET_SINGLE_INCIDENT,
          variables: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.incident = response.data.getSingleIncident.incidents[0]
        }
        )
    }

  },
  created () {
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.role = userRoles[0]['name']
    this.video_cdn = process.env.VUE_APP_VIDEOS_CDN_LINK
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.video_server_cdn = process.env.VUE_APP_SERVER_HTTP_URL
    this.get()

  }
}
</script>
